const ssc = [
  {
    name: '即时开奖',
    alias: 'Jishikaijiang',
    f: 0
  },
  {
    name: '路珠分析',
    alias: 'Luzhufenxi',
    f: 0
  },
  {
    name: '综合分析',
    alias: 'Zonghefenxi',
    f: 0
  },
  {
    name: '冷热分析',
    alias: 'Lenrefenxi',
    f: 0
  },
  {
    name: '号码统计',
    alias: 'Haomatongji'
  },
  {
    name: '大小单双历史',
    alias: 'Daxiaodanshuanglishi'
  },
  {
    name: '基本走势',
    alias: 'Jibenzoushi'
  },
  {
    name: '历史号码统计',
    alias: 'Lishihaomatongji'
  },
  {
    name: '号码路珠',
    alias: 'Haomaluzhu',
    f: 0
  },
  {
    name: '每日长龙统计',
    alias: 'Meirichanglongtongji'
  },
  {
    name: '两面数据统计',
    alias: 'Liangmianshujutongji'
  },
  {
    name: '定位走势',
    alias: 'Dingweizoushi'
  },
  {
    name: '形态走势',
    alias: 'Xingtaizoushi'
  },
  {
    name: '龙虎走势',
    alias: 'Longhuzoushi'
  }
];
const xyrb = [
  {
    name: '即时开奖',
    alias: 'Jishikaijiang',
    f: 0
  }
];

const PK10 = [
  {
    name: '即时开奖',
    alias: 'Jishikaijiang',
    f: 0
  },
  {
    name: '路珠分析',
    alias: 'Luzhufenxi',
    f: 0
  },
  {
    name: '冷热分析',
    alias: 'Lenrefenxi',
    f: 0
  },
  {
    name: '大小单双历史',
    alias: 'Daxiaodanshuanglishi'
  },
  {
    name: '冠亚和走势',
    // alias: 'Guanyahezoushi'
    alias: 'Hezhizoushi'
  },
  {
    name: '龙虎统计',
    alias: 'Longhutongji'
  },
  {
    name: '号码前后路珠',
    alias: 'Haomaqianhouluzhu'
  },
  {
    name: '号码规律统计',
    alias: 'Haomaguilvtongji'
  },
  {
    name: '今日号码统计',
    alias: 'Haomatongji'
  },
  {
    name: '位置走势',
    // alias: 'Weizhizoushi'
    alias: 'Dingweizoushi'
  },
  {
    name: '两面数据统计',
    alias: 'Liangmianshujutongji'
  }
];
const nn = PK10;
const lhc = [
  {
    name: '即时开奖',
    alias: 'LhcJishikaijiang',
    f: 0
  }
];
const ks = [
  {
    name: '即时开奖',
    alias: 'Jishikaijiang',
    f: 0
  },
  {
    name: '每日长龙统计',
    alias: 'Meirichanglongtongji'
  },
  {
    name: '总和路珠',
    alias: 'Zongheluzhu'
  },
  {
    name: '号码路珠',
    alias: 'Haomaluzhu',
    f: 0
  },
  {
    name: '基本走势',
    alias: 'Jibenzoushi'
  },
  {
    name: '定位走势',
    alias: 'Dingweizoushi'
  },
  {
    name: '和值走势',
    alias: 'Hezhizoushi'
  },
  {
    name: '大小走势',
    alias: 'Daxiaozhoushi'
  },
  {
    name: '奇偶走势',
    alias: 'Jiouzoushi'
  },
  {
    name: '历史号码统计',
    alias: 'Lishihaomatongji'
  }
];
const three = [
  {
    name: '即时开奖',
    alias: 'Jishikaijiang',
    f: 0
  }
];
const choose5 = [
  {
    name: '即时开奖',
    alias: 'Jishikaijiang',
    f: 0
  },
  {
    name: '路珠分析',
    alias: 'Luzhufenxi',
    f: 0
  },
  {
    name: '大小单双历史',
    alias: 'Daxiaodanshuanglishi'
  },
  {
    name: '基本走势',
    alias: 'Jibenzoushi'
  },
  {
    name: '号码分布',
    alias: 'Haomafenbu'
  },
  {
    name: '总和路珠',
    alias: 'Zongheluzhu'
  },
  {
    name: '今日号码统计',
    alias: 'Haomatongji'
  },
  {
    name: '冷热分析',
    alias: 'Lenrefenxi',
    f: 0
  },
  {
    name: '每日长龙统计',
    alias: 'Meirichanglongtongji'
  },
  {
    name: '和值走势',
    alias: 'Hezhizoushi'
  },
  {
    name: '定位走势',
    alias: 'Dingweizoushi'
  },

  {
    name: '龙虎走势',
    alias: 'Longhuzoushi'
  }
];

const hpten = [
  {
    name: '即时开奖',
    alias: 'Jishikaijiang'
  },
  // {
  //   name: '路珠分析',
  //   alias: 'Luzhufenxi'
  // },
  {
    name: '大小单双历史',
    alias: 'Daxiaodanshuanglishi'
  },
  // {
  //   name: '基本走势',
  //   alias: 'Jibenzoushi'
  // },
  {
    name: '号码分布',
    alias: 'Haomafenbu'
  },
  {
    name: '总和路珠',
    alias: 'HPZongheluzhu'
  },
  {
    name: '合数单双路珠',
    alias: 'Heshudanshuangluzhu'
  },
  {
    name: '尾数大小路珠',
    alias: 'weishuluzhu'
  },
  {
    name: '中发白路珠',
    alias: 'zhongfabailuzhu'
  },
  {
    name: ' 龙虎路珠',
    alias: 'Longhuluzhu'
  },
  {
    name: '东南西北路珠',
    alias: 'dongnanxibeiluzhu'
  },
  {
    name: '大小单双路珠',
    alias: 'Daxiaodanshuangluzhu'
  },
  {
    name: '今日号码统计',
    alias: 'Haomatongji'
  },
  // {
  //   name: '冷热分析',
  //   alias: 'Lenrefenxi',
  //   f: 0
  // },
  {
    name: '每日长龙统计',
    alias: 'Meirichanglongtongji'
  },
  {
    name: '两面数据统计',
    alias: 'Liangmianshujutongji'
  },
  {
    name: '历史号码统计',
    alias: 'Lishihaomatongji'
  },
  {
    name: '号码路珠',
    alias: 'Haomaluzhu'
  },
  {
    name: '大小走势',
    alias: 'Daxiaozhoushi'
  },
  {
    name: '奇偶走势',
    alias: 'Jiouzoushi'
  }
];

export default {
  ssc,
  xyrb,
  nn,
  PK10,
  lhc,
  ks,
  three,
  choose5,
  hpten
};



// WEBPACK FOOTER //
// ./src/helpers/trendMenus.js